import { WordingService } from '../services/WordingService';
import { DOMElement } from '../utils/DOMElement';

/**
 * Class managing error to be displayed on captcha stage.
 */
export class CaptchaError {
  static errorDivSelector = '#captchaError';

  static errorTitleSelector = '#captchaErrorTitle';

  static errorTextSelector = '#captchaErrorText';

  /**
   * Constructor of the CaptchaError.
   */
  constructor() {
    this.errors = {
      invalid: {
        title: WordingService.getWording('invalidCaptchaErrorTitle'),
        text: WordingService.getWording('invalidCaptchaErrorText'),
      },
    };
    this.errorDiv = document.querySelector(CaptchaError.errorDivSelector);
    this.errorTitle = document.querySelector(CaptchaError.errorTitleSelector);
    this.errorText = document.querySelector(CaptchaError.errorTextSelector);
  }

  /**
   * Sets sentences in title and text elements.
   */
  handleInvalidCaptchaError() {
    this.errorTitle.innerHTML += this.errors.invalid.title;
    this.errorText.innerHTML = this.errors.invalid.text;
  }

  /**
   * Changes style of the CaptchaError DOM element to display it.
   */
  displayCaptchaError() {
    DOMElement.removeClass('hide', this.errorDiv);
    DOMElement.addClass('disp', this.errorDiv);
    this.errorTitle.focus();
  }

  /**
   * Hide the CaptchaError and resets the text and title.
   */
  hideError() {
    DOMElement.removeClass('disp', this.errorDiv);
    DOMElement.addClass('hide', this.errorDiv);
    this.errorTitle.innerHTML = '';
    this.errorText.innerHTML = '';
  }
}
